<template>
  <div class="JumpTemplate">
    <div class="JumpTLeft" ref="courseSubShow" :style="myIframeStyle">
      <div class="topIframe" :style="topIframe" ref="topIframe">
        <div class="iframe_mask" v-show="iframeDrag"></div>
        <iframe
          width="100%"
          height="100%"
          :src="topIframeUrl"
          frameborder="0"
        ></iframe>
      </div>
      <div
        class="iframeDrapLineTB"
        @mousedown.stop="iframeLineMoveTB($event)"
        v-show="bottomIframeUrl"
      ></div>
      <div class="bottomIframe" v-if="bottomIframeUrl">
        <div class="iframe_mask" v-show="iframeDrag"></div>
        <el-button
          size="mini"
          class="closeChildrenIframe"
          @click="answerBoardThreeScreen()"
          type="primary"
        >关闭
        </el-button>
        <iframe
          width="100%"
          height="100%"
          :src="bottomIframeUrl"
          frameborder="0"
        ></iframe>
      </div>
    </div>

    <!-- 拖拽线 -->
    <div v-if="diaLayout === '左右'" class="code_line"
         @mousedown.stop="lineMove($event)"
    >
         <span class="code_line_icon">
           <svg
             style="width: 20px; height: 13px;"
             class="icon svg-icon"
             aria-hidden="true"
           >
            <use xlink:href="#icon-tuozhuai1"></use>
          </svg>
        </span>
    </div>

    <div class="JumpTRight"></div>

    <div
      ref="dragIcon"
      v-drag
      v-if="isSmall"
      :style="dragIconStyle"
      class="dragIcon"
    >
      <i class="el-icon-copy-document"></i>
    </div>
    <!-- 浮窗 -->
    <el-dialog
      v-dialogDrag
      :close-on-click-modal="false"
      :modal="false"
      :visible.sync="dialogVisible"
      :show-close="false"
      customClass="customHeight"
      class="courseSubDialog"
    >
      <span class="dia_span">
        <span style="font-size: 11px;">字号：</span>
        <el-radio-group @change="fontChange" v-model="fontSize">
          <el-radio-button label="默认"></el-radio-button>
          <el-radio-button label="小号"></el-radio-button>
        </el-radio-group>
        <span style="font-size: 11px;">布局：</span>
        <el-radio-group v-model="diaLayout" @change="layoutChange">
          <el-radio-button label="浮窗"></el-radio-button>
          <el-radio-button label="左右"></el-radio-button>
          <!--            <el-radio-button label="上下"></el-radio-button>-->
        </el-radio-group>
        <template v-if="diaLayout === '浮窗'">
            <i v-if="isMini" @click="small" class="small_icon el-icon-minus"></i>
            <i
              v-if="isHalf"
              @click="huanyuan"
              class="large_icon el-icon-copy-document"
            ></i>
           <i v-else @click="large" class="large_icon el-icon-full-screen"></i>
        </template>

        <i
          v-bury="{ route: $route, template: activeOne }"
          @click="back"
          class="el-icon-back"
        ></i>
      </span>
      <el-tabs style="padding: 0 10px;height: 100%" v-model="activeName">
        <el-tab-pane label=" 题 面 " name="first">
          <div
            class="editorShowArea ql-editor"
            :class="{ font_size: changeFont }"
            style="user-select: text"
            v-if="activeOne.resourceType == 3"
            v-html="activeOne.content"
          ></div>
        </el-tab-pane>
        <el-tab-pane label="答案展示" name="second" v-if="isShowComponent()">
          <my-component
            :companyCode="templateCode"
            @taskSubmit="taskSubmit"
            :isShow="
              userType == 0 ||
                userType == 1 ||
                (isBtn && !!activeOne.show) ||
                scoreType === 'dev'
            "
            :optObject="optObject"
            :refresh="answerRefresh"
            :catalogId="catalogId"
            :courseType="courseType"
            :type="type"
            :myId="activeOne.id"
          ></my-component>
        </el-tab-pane>
        <el-tab-pane label="附件" name="third" style="height: 732px">
          <div class="file_lists" v-if="questionEnclosure.length">
            <div
              class="file_item"
              v-for="item in questionEnclosure"
              :key="item.id"
              @click.stop="handleSelectedItem(item)"
              :class="{ selected_item: selectedItem.id === item.id }"
            >
              {{ item.name }}
            </div>

            <!-- <div @click.stop="handleSelectedItem(item)" v-for="item in questionEnclosure" :key="item.id" class="file_item">
              <el-button type="primary" plain >{{ item.name }}</el-button>
            </div> -->
          </div>
          <div class="file_look" v-if="questionEnclosure.length">
            <!-- <div v-if="!selectedItem.id" class="default_file_look">
              文件预览
            </div> -->
            <div class="selected_file_look" v-if="selectedItem.id">
              <iframe
                width="100%"
                height="100%"
                :src="selectedFileUrl"
                frameborder="0"
              ></iframe>
            </div>
          </div>
          <div class="file_empty" v-else>暂无数据</div>
        </el-tab-pane>
      </el-tabs>
      <div class="operations">
        <platform-btn
          :type="type"
          :courseId="courseId"
          :classId="classId"
          :catalogId="catalogId"
          :listItem="activeOne"
          :myStation="myStation"
          isChild
          :buttonShowArr="platformName"
          :childrenBtn="childrenBtn"
          @platformJump="platformJump"
        >
        </platform-btn>

        <el-button
          class="btnStyle btnBlueStyle"
          @click="answerCompareBtn"
          @dblclick="dblclick"
          v-if="scoreType === 'dev'"
          style="margin-left: 10px"
        >答案对比
        </el-button>
        <el-button
          class="btnStyle btnBlueStyle"
          @click="showFeedBack"
          @dblclick="dblclick"
          style="margin-left: 10px"
        >意见反馈
        </el-button>
        <el-button
          class="btnStyle btnBlueStyle"
          @click="handleRefresh"
          @dblclick="dblclick"
          v-if="isBtn"
          style="margin-left: 10px"
        >任务提交
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      top="38vh"
      width="422px"
      title="提示"
      :show-close="false"
      destroy-on-close
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      append-to-body
      class="count_down_dialog"
    >
      <div v-if="isShowTeamWeight()" class="count_down_main">
        <template v-if="teamWeight >= 0">
          <p>本题总分:10</p>
          <p v-if="Number(type) === 3">
            本题本岗位总分:{{ Number(rolesWeight) }}
          </p>
          <p v-if="Number(type) === 3">本岗位得分:{{ Number(teamWeight) }}</p>
          <p v-else>本题得分:{{ Number(teamWeight) }}</p>
        </template>
        <div
          v-else-if="Number(type) === 3 && teamWeight == -2"
          class="teamWeightMsg"
        >
          <!--  没有有效的岗位步骤 -->
          本任务对当前岗位不做考核
        </div>
        <div v-else-if="teamWeight == -3" class="teamWeightMsg">
          <!--  资源库还没有加载完整 -->
          资源加载中，请稍后再试。
        </div>
        <div class="teamWeightMsg">
          任务提交成功！
        </div>
      </div>
      <div class="teamWeightMsg" v-else>
        任务提交成功！
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="back">返回上一页</el-button>
        <el-button size="mini" type="primary" @click="innerVisible = false"
        >留在此页
        </el-button>
      </div>
    </el-dialog>

    <!-- 意见反馈 -->
    <el-dialog
      title="意见反馈"
      :visible.sync="feedBackShow"
      width="650px"
      center
      custom-class="feedBack"
      class="feed_back"
      :modal="false"
      destroy-on-close
      :close-on-click-modal="false"
    >
      <div class="from_cont">
        <el-form
          inline
          :model="feedForm"
          :rules="feedRules"
          ref="feedForm"
          label-position="left"
          label-width="100%"
        >
          <el-form-item label="问题类型" prop="questionType">
            <el-radio-group v-model="feedForm.questionType">
              <el-radio label="试题评分"></el-radio>
              <el-radio label="业务系统"></el-radio>
              <el-radio label="教学平台"></el-radio>
              <el-radio label="产品建议"></el-radio>
              <el-radio label="其他"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="试题编号"
            prop="questionCode"
            v-if="feedForm.questionType == '试题评分'"
          >
            <el-input v-model="feedForm.questionCode" maxlength="20"></el-input>
            <span>（例如：TY-SS-0703）</span>
          </el-form-item>
          <el-form-item label="问题描述" prop="questionDescribe">
            <editor v-model="feedForm.questionDescribe"></editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <span
          class="zl_button zl_whiteButton"
          @click="handleFeedBack(false, 'feedForm')"
        >取 消</span
        >
        <span
          class="zl_button zl_blueButton"
          @click="handleFeedBack(true, 'feedForm')"
        >确 定</span
        >
      </span>
    </el-dialog>

    <!-- 意见反馈成功提示 -->
    <el-dialog
      title="意见反馈"
      :visible.sync="feedBackCloseShow"
      width="580px"
      center
      custom-class="feedBack"
      :modal="false"
      :close-on-click-modal="false"
      destroy-on-close
      class="feed_back"
    >
      <div class="close_cont">
        <!--        <img src="./img/success.png"/>-->
        <div class="title">
          <p>提交成功</p>
          <p>感谢您的反馈，我们会尽快解决您的问题</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <span
          class="zl_button zl_whiteButton"
          @click="feedBackCloseShow = false"
        >关 闭</span
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *   2022.7.8 下午15：45 wjl
   *   写一个学习组件
   */
  import "./scss/dialogsass.scss";
  import myComponent from "./newComponent";
  import editor from "./wjlEditor/index.vue";
  import platformBtn from "./platformBtn/index";
  import * as api from "../api/courseApi";

  export default {
    name: "JumpTemplate",
    props: {
      value: {
        // iframe地址
        type: String,
        default: ""
      },
      childrenIframeUrl: {
        type: String,
        default: ""
      },
      activeOne: {
        type: Object,
        default: () => {
        }
      },
      isBtn: {
        type: Boolean,
        default: false
      },
      catalogId: {
        type: [String, Number],
        default: false
      },
      templateCode: {
        type: [String, Number],
        default: false
      },
      type: {
        type: [String, Number],
        default: ""
      },
      platform: {
        type: String,
        default: ""
      },
      myStation: {
        type: Array,
        default: () => [{}]
      },
      platformName: {
        type: Array
      }
    },
    components: {
      myComponent,
      platformBtn,
      editor
    },
    data() {
      var validateEdtior = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入问题描述"));
        } else {
          callback();
        }
      };
      return {
        // that: this,
        // drapMove: false,
        iframeDrag: false,
        topIframeUrl: this.value,
        bottomIframeUrl: this.childrenIframeUrl,
        myIframeStyle: {
          width: "65%",
          height: "100%"
        },
        topIframe: {
          width: "100%",
          height: "100%"
        },
        dragIconStyle: {
          right: "40px",
          bottom: "70px"
        },
        dialogVisible: true,
        isSmall: false,
        fontSize: "默认",
        diaLayout: "左右",
        changeFont: false,
        isHalf: false,
        isMini: true,
        activeName: "first", // tag切换标记
        answerRefresh: 0,
        innerVisible: false,

        //
        prodId: sessionStorage.getItem("prodId"), // 产品id，108 === 1+X课程（免费）

        catalogType: this.$route.query.catalogType,
        courseId: this.$route.query.courseId || this.$route.query.id,
        courseName: this.$route.query.courseName,
        classId: this.$route.query.classId,
        className: this.$route.query.className,
        classStatus: this.$route.query.classStatus,
        subjectId: this.$route.query.subjectId,
        courseType: this.$route.query.courseType, // 1 1+X平台、2 单项训练 3综合平台
        isPay: this.$route.query.isPay, // 0免费， 1正常
        scoreType: this.$route.query.scoreType || "", // 0免费， 1正常
        optObject: {
          //科目id和班级id
          id: this.$route.query.courseId || this.$route.query.id,
          classId: this.$route.query.classId
        },
        professional: sessionStorage.getItem("professional"), // 1智能审计 2智能财税 3智能估值 8社交电商 9新专业课 12 IT课,26 金砖IT课
        productFlag: sessionStorage.getItem("productFlag"), // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务, 5、新真实任务
        schoolId: sessionStorage.getItem("deptId"), // 机构id
        userType: sessionStorage.getItem("userType"), //

        //
        teamWeight: 0,
        rolesWeight: 0, // 本题本岗位总分，只针对综合实训
        //
        /* 意见反馈 */
        feedBackShow: false,
        feedForm: {
          questionType: "试题评分",
          questionCode: "",
          questionDescribe: ""
        },
        feedRules: {
          questionType: [
            {required: true, message: "请选择问题类型", trigger: "change"}
          ],
          questionCode: [
            {required: true, message: "请输入试题编号", trigger: "blur"}
          ],
          questionDescribe: [
            {required: true, validator: validateEdtior, trigger: "blur"}
          ]
        },
        feedBackCloseShow: false,
        //
        childrenBtn: [],

        //附件中的数据
        questionEnclosure: [], // 试题中的附件
        selectedItem: {}, //选中这一项
        selectedFileUrl: "" //选中文件的地址
      };
    },
    watch: {
      childrenIframeUrl(val) {
        this.bottomIframeUrl = val;
        if (val) {
          this.$set(this.topIframe, "height", "50%");
        }
      },
      "selectedItem.id"(val) {
        console.log("selectedItem.id:", val);
        if(process.env.NODE_ENV === 'native'){
          this.selectedFileUrl = this.selectedItem.newAttaUrl;
        }else{
          this.selectedFileUrl = process.env.PREVIEW_URL + this.electedItem.newAttaUrl ;
        }
      }
    },
    created() {
      this.isSmall = false;
      this.topIframeUrl = this.value;
      if (this.topIframeUrl && this.activeOne.id) {
        this.getQuestionEvent(this.activeOne.id);
      }
      //新增的附件接口
      this.getAttachmentList(this.activeOne.id);
    },
    mounted() {
      this.layoutChange('左右')
    },
    methods: {
      //选中的某一项
      handleSelectedItem(item) {
        this.selectedItem = item;
      },
      // //根据试题id查询附件列表
      getAttachmentList(id) {
        api.getAttachmentList({questionId: id}).then(res => {
          if (res.code == 0) {
            this.questionEnclosure = res.data;
          } else {
            this.questionEnclosure = [];
          }
        });
      },
      //  获取试题的事项，用于获取主子关系
      getQuestionEvent(id) {
        this.childrenBtn = [];
        api.getQuestionEventById(id).then(res => {
          if (res.code == 0) {
            if (res.data && res.data.length) {
              let child = [];
              let o = {};
              let setObj = {}; // 重复项
              let pretendChild = [
                "BigDataOS",
                "ExcelOS",
                "ExcelCustomOS",
                "FZBAOSHUI",
                "RPAOS"
              ]; // 伪子级
              [].forEach.call(res.data, item => {
                let platform = "";
                if (
                  this.platformName[item.sort] &&
                  this.platformName[item.sort].platform
                ) {
                  platform = this.platformName[item.sort].platform;
                }

                if (!platform || platform === this.platform) return o[item.parentId] = true;

                if (pretendChild.includes(platform)) {
                  if (item.sort === 0) return o[item.parentId] = true;
                  if (!setObj[platform]) {
                    setObj[platform] = 1;
                  } else {
                    setObj[platform]++;
                  }
                  if (setObj[platform] && setObj[platform] === 1) {
                    // if (!platform || platform === this.platform) return;
                    child.push(item.sort);
                  }
                } else if (item.parentId) {
                  if (o[item.parentId]) {
                    if (!setObj[platform]) {
                      setObj[platform] = 1;
                    } else {
                      setObj[platform]++;
                    }
                    if (setObj[platform] && setObj[platform] === 1) {
                      // if (!platform || platform === this.platform) return;
                      child.push(item.sort);
                    }
                  } else {
                    o[item.parentId] = true;
                  }
                }
              });
              this.childrenBtn = [...child];

              console.log("--子平台：", this.childrenBtn);
            }
          }
        });
      },
      /*
       *  平台跳转
       *   openType  链接打开方式，0主页面打开。1副页面打开，2新窗口打开
       *   author: wjl
       */
      platformJump(data, openType) {
        if (!data.iframeUrl) return;
        this.dialogVisible = true;
        this.isSmall = false;

        this.$nextTick(() => {
          if (openType === 0) {
            this.topIframeUrl = data.iframeUrl;
          } else if (openType === 1) {
            this.$set(this.topIframe, "height", "50%");
            this.bottomIframeUrl = data.iframeUrl;
          } else if (openType === 2) {
            window.open(data.iframeUrl);
          }
          this.isBtn = true;
          // 保存资源学习进度状态
          this.$emit("insertDirectory", this.activeOne.isFinish);
        });
      },

      /** 轴挪动 */
      lineMove(ev) {

        let that = this;
        let screenX = ev.screenX;
        let refWidth = that.$refs.courseSubShow.offsetWidth;
        that.iframeDrag = true;
        document.onmousemove = e => {
          window.event.preventDefault(); //
          window.event.cancelBubble = true; //IE
          let width = e.screenX - screenX + refWidth
          that.$set(that.myIframeStyle, 'width', width + 'px');

          $(".courseSubDialog").css({
            width: `calc(100% - ${width + 'px'} )`,
            height: "100%",
            left: width + 'px',
            top: 0
          });

          that.$forceUpdate();

        };
        document.onmouseup = function () {
          document.onmousemove = null;
          that.iframeDrag = false;
        };
      },

      // 保存意见反馈
      handleFeedBack(type, formName) {
        if (type) {
          this.$refs[formName].validate(valid => {
            if (valid) {
              api.saveFeedBack(this.feedForm).then(res => {
                if (res.code == 0) {
                  this.$refs[formName].resetFields();
                  this.feedBackShow = false;
                  this.feedBackCloseShow = true;
                } else {
                  this.$messageError(res.msg);
                }
              });
            } else {
              return false;
            }
          });
        } else {
          this.$refs[formName].resetFields();
          this.feedBackShow = false;
        }
      },

      // 关闭浮窗
      back() {
        this.innerVisible = false; // 关闭二次确认框
        this.isHalf = false;
        this.isMini = true;
        this.topIframeUrl = "";
        this.bottomIframeUrl = "";
        this.$set(this.topIframe, "height", "100%");
        this.$emit("input", "");
        this.$emit("refresh", "");
      },

      // 组件内出发提交
      taskSubmit(bool, rolesWeight, ease) {
        /**
         *  bool 总分
         *  -2时代表该用户的岗位没有步骤（也排除了0权重的步骤）
         *  ease  true是任务提交触发，还是 false 智能评分触发的
         **/

        if (Number(bool) == -3) {
          this.teamWeight = Number(bool); // 页面没加载完
          this.innerVisible = true;
        } else if (Number(bool) == -2) {
          // 针对综合实训，判断试题中有没有用户拥有的岗位
          this.teamWeight = Number(bool);
          this.innerVisible = true;
        } else if (Number(bool) >= 0) {
          this.teamWeight = Number(bool);
        } else {
          this.teamWeight = 0;
        }
        this.rolesWeight = rolesWeight;
        // ease  true是任务提交触发，还是 false 智能评分触发的
        if (ease) this.innerVisible = true;
      },
      // 是否展示答案模块
      isShowComponent() {
        if (Number(this.prodId) === 108) {
          // 指定机构不展示
          return false;
        } else if (Number(this.courseType) === 1) {
          //  1 1+X平台、2 单项训练 3综合平台
          return false;
        } else if (Number(this.isPay) === 0) {
          // 学生登录，免费课程不展示
          return false;
        } else {
          // 默认是展示
          return true;
        }
      },
      // 是否展示分数
      isShowTeamWeight() {
        /* 单项设置的机构直接取消，所有单项都展示 */
        // let flag = false;
        // let schoolArr = JSON.parse(sessionStorage.getItem("deptIds"));   //开通单项评分功能的院校
        // let deptId = Number(sessionStorage.getItem("deptId"));
        // flag = schoolArr.includes(deptId);

        if (this.productFlag === "2") {
          // 单项都展示
          return true;
        } else if (Number(this.prodId) === 108) {
          // 指定机构不展示分数
          return false;
        } else if (Number(this.isPay) === 1 || Number(this.isPay) === 2) {
          // 0免费， 1标准， 2产品。
          return true;
        } else {
          return false;
        }
      },

      //任务提交
      handleRefresh() {
        this.$tipsDialog(
          "提示",
          "请确认是否提交您的作答结果？",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        ).then(() => {
          if (Number(this.prodId) === 108) {
            this.innerVisible = true;
          } else {
            if (Number(this.isPay) === 1 || Number(this.isPay) === 2) {
              // 0免费， 1标准， 2产品。 免费课不走评分
              ++this.answerRefresh;
            } else {
              this.innerVisible = true;
            }
          }
          // 保存资源学习进度状态
          this.$emit("insertDirectory", 1);
        });
      },

      fontChange(val) {
        //字号切换
        if (val === "默认") {
          this.changeFont = false;
          this.$messageSuccess("已切换默认字号");
        } else if (val === "小号") {
          this.changeFont = true;
          this.$messageSuccess("已切换小号字号");
        }
      },
      //弹窗上下切换
      layoutChange(val) {
        if (val === "左右") {
          this.$set(this.myIframeStyle, "width", "65%");
          $(".courseSubDialog").css({
            width: "35%",
            height: "100%",
            left: "65%",
            top: 0
          });
          $(".customHeight .el-dialog__header").css("cursor", "default");
          $(".customHeight .el-dialog__body").css("cursor", "default");
          $(".customHeight")
            .css("cursor", "default")
            .css({width: "100%", height: "100%", left: 0, top: 0, margin: "0"});
        } else if (val === "浮窗") {
          this.$set(this.myIframeStyle, "width", "100%");
          $(".courseSubDialog").css({
            width: "100%",
            height: "100%",
            margin: 0,
            left: 0,
            top: 0
          });
          $(".customHeight").css({
            width: "50%",
            height: "50%",
            left: "50%",
            top: "50%"
          });
          $(".customHeight .el-dialog__header").css("cursor", "move");
        }
      },
      // 浮窗变浮标
      small() {
        this.dialogVisible = false;
        this.isSmall = true;
      },
      // 浮窗全屏
      large() {
        $(".customHeight").css({
          width: "100%",
          height: "100%",
          left: "0",
          top: "0",
          "margin-top": "0"
        });
        this.isHalf = true;
      },
      // 从全屏还原
      huanyuan() {
        this.isHalf = false;
        $(".customHeight").css({
          width: "50%",
          height: "30%",
          left: "50%",
          top: "70%"
        });
      },
      // 从最小化还原
      largeHalf() {
        // console.log('--111-', this.drapMove)
        // if (this.drapMove) {
        //   this.drapMove = false
        //   return
        // }
        // this.isHalf = false;
        this.isMini = true;
        this.dialogVisible = true;
        this.isSmall = false;
      },
      // 关闭子iframe
      answerBoardThreeScreen() {
        this.bottomIframeUrl = "";
        this.$set(this.topIframe, "height", "100%");
      },
      /* 上下拖拽 */
      iframeLineMoveTB(ev) {
        let that = this;
        let screenY = ev.screenY;
        let refHeight = that.$refs.topIframe.offsetHeight;
        that.iframeDrag = true;
        document.onmousemove = e => {
          window.event.preventDefault(); //
          window.event.cancelBubble = true; //IE
          let height = e.screenY - screenY + refHeight;
          that.$set(that.topIframe, "height", height + "px");
          that.$forceUpdate();
        };
        document.onmouseup = function () {
          document.onmousemove = null;
          that.iframeDrag = false;
        };
      },

      // 发起意见反馈
      showFeedBack() {
        this.feedForm = {
          questionType: "试题评分",
          questionCode: "",
          questionDescribe: ""
        };
        if (this.$refs["feedForm"] !== undefined) {
          this.$refs["feedForm"].resetFields();
        }
        this.feedBackShow = true;
      },
      // 跳转答案对比
      answerCompareBtn() {
        let newUrl = this.$router.resolve({
          path: "/answerCompare",
          query: {
            classId: this.classId,
            userId: sessionStorage.getItem("userId"),
            courseId: this.courseId,
            questionId: this.activeOne.id,
            teamId: this.myStation.length ? this.myStation[0].teamId : "",
            type: this.type
          }
        });
        window.open(newUrl.href, "_blank");
      },
      dblclick() {
      }
    },
    //注册局部组件指令
    directives: {
      drag(el, binding, vnode) {
        let clientOffset = {};
        let that = vnode.context; //通过vnode参数来获取this,此时的that就可以获取到js中的this
        el.onmousedown = function (e) {
          var disx = e.pageX - el.offsetLeft;
          var disy = e.pageY - el.offsetTop;
          clientOffset.clientX = event.clientX;
          clientOffset.clientY = event.clientY;
          document.onmousemove = function (e) {
            el.style.left = e.pageX - disx + "px";
            el.style.top = e.pageY - disy + "px";

            that.dragIconStyle = {};
            that.$set(that.dragIconStyle, "left", e.pageX - disx + "px");
            that.$set(that.dragIconStyle, "top", e.pageY - disy + "px");
          };

          document.onmouseup = function () {
            document.onmousemove = document.onmouseup = null;
          };
        };
        el.addEventListener("mouseup", event => {
          //鼠标抬起后的事件，判断是拖拽还是点击
          let clientX = event.clientX;
          let clientY = event.clientY;
          if (
            clientX === clientOffset.clientX &&
            clientY === clientOffset.clientY
          ) {
            //这里触发点击事件，将click方法移入这里
            that.largeHalf();
          } else {
            //这里是拖拽事件
            return;
          }
        });
      }
      // drag: function (el, binding) {
      //   let dragBox = el; //获取当前元素
      //   let innerWidth = window.innerWidth,
      //     innerHeight = window.innerHeight;
      //   let app = document.getElementById('app')
      //   let dragIconDialog = document.getElementsByClassName('dragIconDialog')[0];
      //   binding.value.drapMove = false;
      //
      //   dragBox.onmousedown = (e) => {
      //
      //     console.log('--log--', innerWidth, innerHeight, binding)
      //
      //     app.style.userSelect = 'none'
      //     //算出鼠标相对元素的位置
      //     let disX = e.clientX - dragBox.offsetLeft,
      //       disY = e.clientY - dragBox.offsetTop,
      //       clientWidth = dragBox.clientWidth,
      //       clientHeight = dragBox.clientHeight;
      //     document.onmousemove = (e) => {
      //       dragIconDialog.style.display = 'block';
      //       if (!binding.value.drapMove) {
      //         binding.value.drapMove = true
      //       }
      //
      //       //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
      //       let left = e.clientX - disX;
      //       let top = e.clientY - disY;
      //       if (left < 0) left = 0;
      //       if (top < 0) top = 0;
      //       if (left + clientWidth > innerWidth) left = innerWidth - clientWidth;
      //       if (top + clientHeight > innerHeight) top = innerHeight - clientHeight;
      //
      //       //移动当前元素
      //       dragBox.style.left = left + "px";
      //       dragBox.style.top = top + "px";
      //     };
      //     document.onmouseup = () => {
      //       //鼠标弹起来的时候不再移动
      //       document.onmousemove = null;
      //       //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
      //       document.onmouseup = null;
      //       app.style.userSelect = 'text'
      //       if (binding.value.drapMove) {
      //         dragIconDialog.style.display = 'none';
      //       }
      //       binding.value.drapMove = false
      //     };
      //   };
      // },
    }
  };
</script>

<style scoped lang="scss">
  .JumpTemplate {
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #ffffff;
    z-index: 20;
    left: 0;
    top: 0;
    display: flex;

    .JumpTLeft {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      /* 左上 */
      .topIframe {
        width: 100%;
        height: 100%;
      }

      // 上下拖拽线
      .iframeDrapLineTB {
        height: 5px;
        background: #cccccc;
        cursor: ns-resize;
      }

      /* 左下 */
      .bottomIframe {
        flex: 1;
        position: relative;
        /* 关闭按钮 */
        .closeChildrenIframe {
          position: absolute;
          top: 5px;
          right: 35px;
          background-color: #1373e6;
        }
      }
    }

    .code_line {
      width: 0px;
      height: 100%;
      position: relative;

      .code_line_icon {
        cursor: ew-resize;
        padding: 0px 8px;
        position: absolute;
        background: rgba(24, 144, 255, 0.2);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(90deg);
        z-index: 5000;

        &:hover {
          background: rgba(24, 144, 255, 0.5);

          svg {
            fill: #ffffff;
          }
        }
      }

      svg {
        fill: #1890FF;
      }
    }

    .JumpTRight {
      flex: 1;
    }

    .dragIcon {
      position: fixed;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-color: rgba($color: #edf4ff, $alpha: 0.7);
      line-height: 40px;
      text-align: center;
      color: #fff;
      z-index: 999;
      cursor: pointer;
      border: 1px solid #bdd1ec;

      i {
        font-size: 24px;
        color: #262628;
        line-height: 50px;
      }

      &:hover {
        background-color: rgba($color: #edf4ff, $alpha: 0.9);
      }
    }

    .dragIconDialog {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 998;
      display: none;
    }

    // 蒙层
    .iframe_mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10000;
    }

    .file_lists {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      // margin-top: 30px;
      .file_item {
        // margin-top: 10px;
        // margin-left: 10px;
        box-sizing: border-box;
        height: 40px;
        padding-left: 15px;
        padding-right: 15px;
        margin-right: 7px;
        line-height: 40px;
        border: 1px solid #b3b2b3;
        user-select: none;
        margin-top: 10px;
        border-radius: 4px;

        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;

        &:hover {
          cursor: pointer;
          background: #409eff;
          border-color: #409eff;
          color: #fff;
        }
      }

      .selected_item {
        border: 1px solid #409eff;
        // color: #578ff0;

        background: #409eff;
        border-color: #409eff;
        color: #fff;
      }
    }

    .file_look {
      width: 100%;
      height: 100%;
      margin-top: 20px;

      .default_file_look {
        width: 98%;
        height: 70px;
        border: 1px solid #b3b2b3;
        line-height: 70px;
        text-align: center;
        // display: flex;
        // flex-direction: row;
        // justify-content: center;
        // align-content: center;
      }

      .selected_file_look {
        width: 100%;
        height: 100%;
        border: 1px solid #b3b2b3;
        overflow: hidden;
      }
    }

    .file_empty {
      text-align: center;
      margin-top: 50px;
    }

    .font_size {
      font-size: 12px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/JumpTemplate.vue